import { intersection } from 'lodash/array';
import State from '../stores/State';
import {EDIT_ROLES} from '../constants';

export const roleCanEdit = () => {
  const userRoles = State.get('userRoles').toJS();
  return State.get('loggedIn') && intersection(userRoles, EDIT_ROLES).length > 0;
}

// just an alias for now
export const isAdmin = () => {
  return roleCanEdit()
}




// WEBPACK FOOTER //
// ./webapp/scripts/user.js